import React from 'react';
import { Button } from '../ui/Button';
import { LockIcon, CreditCardIcon } from 'lucide-react';
export function CTASection() {
  return <section className="py-20 px-4 bg-gradient-to-b from-purple-900 to-indigo-900 text-white text-center" data-id="element-51">
      <div className="max-w-4xl mx-auto" data-id="element-52">
        <h2 className="text-3xl md:text-5xl font-bold mb-6 font-heading" data-id="element-53">
          Recupera tu cuerpo y tu energía hoy mismo
        </h2>
        <p className="text-xl text-purple-200 mb-10 max-w-2xl mx-auto" data-id="element-54">
          No dejes pasar otro día sintiéndote agotada e inflamada. Tu cuerpo
          está esperando que le des las herramientas correctas.
        </p>

        <div id="oferta-precio" className="bg-white text-gray-900 rounded-2xl shadow-2xl p-8 md:p-12 max-w-lg mx-auto transform hover:scale-105 transition-transform duration-300" data-id="element-55">
          <div className="text-sm font-bold text-purple-600 uppercase tracking-wide mb-2" data-id="element-56">
            Oferta Limitada
          </div>
          <h3 className="text-3xl font-bold mb-4" data-id="element-57">
            El Código del Metabolismo Silencioso
          </h3>

          <div className="flex items-center justify-center gap-4 mb-8" data-id="element-58">
            <span className="text-gray-400 line-through text-2xl" data-id="element-59">$97</span>
            <span className="text-5xl font-bold text-purple-700" data-id="element-60">$6.36</span>
            <span className="text-gray-500 text-xl" data-id="element-61">USD</span>
          </div>

          <ul className="text-left space-y-3 mb-8 text-gray-600" data-id="element-62">
            <li className="flex items-center" data-id="element-63">
              <span className="text-green-500 mr-2" data-id="element-64">✓</span> Acceso inmediato al
              eBook
            </li>
            <li className="flex items-center" data-id="element-65">
              <span className="text-green-500 mr-2" data-id="element-66">✓</span> Protocolo de 21
              días
            </li>
            <li className="flex items-center" data-id="element-67">
              <span className="text-green-500 mr-2" data-id="element-68">✓</span> Guía de
              alimentación
            </li>
          </ul>

          <Button size="xl" fullWidth withIcon className="mb-4 shadow-purple-500/50" onClick={() => {
          if (window.fbq) {
            window.fbq('track', 'AddToCart', {
              value: 6.36,
              currency: 'USD',
              content_name: 'El Código del Metabolismo Silencioso',
              content_type: 'product'
            });
          }
          window.open('https://codigodelmetabolismo.coresolutionsg.com', '_blank');
        }} data-id="element-69">
            ¡Descargar Ahora!
          </Button>

          <div className="flex items-center justify-center gap-2 text-xs text-gray-500" data-id="element-70">
            <LockIcon className="h-3 w-3" data-id="element-71" />
            <span data-id="element-72">Pago 100% Seguro y Encriptado</span>
          </div>

          <div className="mt-4 flex justify-center gap-2 opacity-60" data-id="element-73">
            <CreditCardIcon className="h-6 w-6" data-id="element-74" />
            {/* Add more payment icons if needed */}
          </div>
        </div>
      </div>
    </section>;
}